import { getCookie } from 'root/src/client/v2/browser/helpers/cookies';
import { useEffect, useState } from 'react';
export const useAuthentication = () => {
    const [authentication, setAuthentication] = useState(getAuthenticationCookies);
    useEffect(() => {
        const handleCookieChange = () => {
            const newAuthentication = getAuthenticationCookies();
            setAuthentication(newAuthentication);
        };
        window.addEventListener('cookiechange', handleCookieChange);
        return () => {
            window.removeEventListener('cookiechange', handleCookieChange);
        };
    }, []);
    return {
        authentication,
    };
};
const getAuthenticationCookies = () => {
    const accessToken = getCookie('accessToken');
    const refreshToken = getCookie('refreshToken');
    const userId = getCookie('userId');
    const email = getCookie('email');
    const groups = getCookie('groups');
    if (typeof accessToken !== 'string'
        || typeof refreshToken !== 'string'
        || typeof email !== 'string'
        || typeof userId !== 'string'
        || typeof groups !== 'string') {
        return undefined;
    }
    return {
        accessToken,
        refreshToken,
        userId,
        email,
        groups: JSON.parse(groups),
    };
};
